import axios from '@axios'

export default {
    namespaced: true,
    state: {
        bodegas: [],
        categorias: [],
        items: [],
        inventarios: [],
        aprobarEgresos: [],
    },
    getters: {
        getBodegas: state => state.bodegas,
        getCategorias: state => state.categorias,
        getItems: state => state.items,
        getInventarios: state => state.inventarios,
        getAprobarEgresos: state => state.aprobarEgresos,
    },
    mutations: {
        SET_BODEGAS(state, bodegas) {
            state.bodegas = bodegas
        },
        SET_CATEGORIAS(state, categorias) {
            state.categorias = categorias
        },
        SET_ITEMS(state, items) {
            state.items = items
        },
        SET_INVENTARIOS(state, inventarios) {
            state.inventarios = inventarios
        },
        SET_APROBAR_EGRESOS(state, aprobarEgresos) {
            state.aprobarEgresos = aprobarEgresos
        },
    },
    actions: {
        fetchBodegas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/marketing/mantenimiento/bodega')
                    .then(response => {
                        commit('SET_BODEGAS', response.data)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        createBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/marketing/mantenimiento/bodega', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updateBodega({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .patch('/api/auth/marketing/mantenimiento/bodega', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCategorias({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/marketing/mantenimiento/categoria')
                    .then(response => {
                        commit('SET_CATEGORIAS', response.data)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        createCategoria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/marketing/mantenimiento/categoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updateCategoria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .patch('/api/auth/marketing/mantenimiento/categoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchItems({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/marketing/mantenimiento/item')
                    .then(response => {
                        commit('SET_ITEMS', response.data)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        createItem({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/marketing/mantenimiento/item', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updateItem({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/marketing/mantenimiento/item/edit', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchInventarios({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/marketing/transacciones/inventario')
                    .then(response => {
                        commit('SET_INVENTARIOS', response.data)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        createInventario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/marketing/transacciones/inventario', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updateInventario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .patch('/api/auth/marketing/transacciones/inventario', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        deleteInventario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .delete('/api/auth/marketing/transacciones/inventario', { data: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchKardex({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/marketing/informes/kardex', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAprobarEgresos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/marketing/transacciones/aprobar-egresos')
                    .then(response => {
                        commit('SET_APROBAR_EGRESOS', response.data)
                        resolve(response)
                    })
                    .catch(error => reject(error))
            })
        },
        postAprobarEgresos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/marketing/transacciones/aprobar-egresos', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
